import RealTimeEditService from './RealTimeEditService';

export default new RealTimeEditService(process.env.NEXT_PUBLIC_BACKEND_HOST);
